import { fromJS } from 'immutable';
import { FINISHED_IMPORTING_PROD } from '../location/location-constants';
import marketReadiness from '../../../utils/marketing-readiness/index.js';
const initialState = fromJS({});

const checkMarketReadiness = (state, productId) => {
  const marketReadinessResults = marketReadiness('product', state.get(productId).toJS());
  const errors = marketReadinessResults.errors;
  const thisProduct = state.get(productId);
  const percentage = (thisProduct.isMarketingReady === true || errors.length === 0) ? 100 : marketReadinessResults.percentage;
  return state.setIn([productId, 'marketingReadinessPercentage'], percentage).setIn([productId, 'marketingReadinessErrors'], errors);
};

export function profileProduct(state = initialState, action) {
  switch (action.type) {
    case 'GET_USER_PRODUCT_PROFILE':
      return checkMarketReadiness(state.set(action.product.productId, fromJS(action.product)), action.product.productId);
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD_STARTING':
      const { id, updateField, updateBody } = action.payload;
      return state.setIn([id, updateField], updateBody);
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD':
      return checkMarketReadiness(state.setIn([action.payload.productId, 'isMarketingReady'], action.payload.isMarketingReady), action.payload.productId);
    case 'DELETE_COVER_IMAGE_FROM_PRODUCT':
      return state.setIn([action.payload.id, 'coverImageUrl'], '');
    case FINISHED_IMPORTING_PROD:
      return state.remove(action.payload.productId);
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/profile/product/product-reducer.js